import { Box, Typography } from "@mui/material";

interface Props {
  /** Letra del grupo ("A", "B"): da el ritmo de lectura de las pantallas del expediente. */
  num: string;
  title: string;
  /** Dato al margen del encabezado, como el avance de carga del grupo. */
  meta?: string;
}

/**
 * Encabezado de un grupo del expediente (`ExpGroup` del diseño): la letra del grupo, su título y
 * un dato al margen. El contenido del grupo lo arma la pantalla debajo.
 */
export const ExpGroup = ({ num, title, meta }: Props) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "baseline",
      justifyContent: "space-between",
      gap: "12px",
      minWidth: 0,
      p: "0 2px 2px",
    }}
  >
    <Box sx={{ display: "flex", alignItems: "baseline", gap: "10px", minWidth: 0 }}>
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: "0.08em",
          color: "primary.main",
          width: 18,
          textAlign: "center",
          bgcolor: "primary.base",
          border: "1px solid",
          borderColor: "primary.light",
          borderRadius: "999px",
          p: "2px 0",
          lineHeight: 1.1,
          flexShrink: 0,
        }}
      >
        {num}
      </Typography>
      <Typography sx={{ fontSize: 14, fontWeight: 600, letterSpacing: "-0.01em", color: "primary.dark" }}>
        {title}
      </Typography>
    </Box>
    {meta && (
      <Typography
        variant="body2"
        sx={{ color: "text.disabled", fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap" }}
      >
        {meta}
      </Typography>
    )}
  </Box>
);
